import './shared-config';
import { getPb } from '@racefriends/shared/pocketbase';

export const pb = getPb();

if (typeof window !== 'undefined') {
  (window as any).pb = pb;
}
